export const homeSafeFormatting = {
  methods: {
    homeSafeFormatting(text) {
      if (!text) {
        return;
      }
      if (text.includes('HomeSafe®')) {
        return text.replace('HomeSafe®', 'Home<em>Safe</em><sup>®</sup>️');
      }
      if (text.includes('HomeSafeTM')) {
        return text.replace('HomeSafeTM', 'Home<em>Safe</em><sup>®</sup>️');
      }
      return text.replace('HomeSafe', 'Home<em>Safe</em><sup>®</sup>️');
    },
  },
};
